import { Options } from '../options.interface';
import { CONTENT_API_CONFIG } from './content-api.config';
import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ArticleFacade, CategoryArticleAlgolia, Contributor } from '@wizbii/utils/models';
import { Observable } from 'rxjs';

@Injectable()
export class ContentWebservice {
  readonly #http = inject(HttpClient);
  readonly #contentApiConfig = inject(CONTENT_API_CONFIG);

  readonly #baseUrl = this.#contentApiConfig.baseUrl;

  getContributor(contributorId: string): Observable<Contributor> {
    return this.#http.get<Contributor>(`${this.#baseUrl}/v1/contributor/${contributorId}`);
  }

  getArticle<T = ArticleFacade>(articleSlug: string): Observable<T> {
    return this.#http.get<T>(`${this.#baseUrl}/v1/facade/${articleSlug}`);
  }

  getFaqArticle(articleSlug: string): Observable<ArticleFacade> {
    return this.#http.get<ArticleFacade>(`${this.#baseUrl}/v1/facade/${articleSlug}`);
  }

  getCategory(categorySlug: string): Observable<CategoryArticleAlgolia> {
    return this.#http.get<CategoryArticleAlgolia>(`${this.#baseUrl}/v1/facet/wizbii-drive-category-${categorySlug}`);
  }

  getArticlesByBlogId<T = ArticleFacade[]>(blogId: string, options?: Options): Observable<T> {
    return this.#http.get<T>(`${this.#baseUrl}/v1/facades/${blogId}`, options);
  }
}
